<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showsnackbar" color="#63028F" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{msg}}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color:white;">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex px-2 xs12 sm12 md10 lg8 xl6 text-left>
        <v-layout pt-6 wrap justify-center>
          <v-flex xs6 lg6>
            <v-btn text block light class="text-capitalize" disabled>
              <span style="font-family:poppinssemibold;font-size:18px;color:#000">Sign Up</span>
            </v-btn>
            <v-progress-linear value="100" color="#63028F"></v-progress-linear>
          </v-flex>
        </v-layout>
        <v-layout pt-6 wrap justify-center>
          <v-flex px-2 xs6 lg4>
            <v-btn @click="customer(true)" block light :color="cust.bgclr">
              <span
                :style="{ color:cust.clr}"
                style="font-family:poppinssemibold;font-size:14px;color:#fff"
              >CUSTOMER</span>
            </v-btn>
          </v-flex>
          <v-flex px-2 xs6 lg4>
            <v-btn @click="seller(true)" block light :color="sell.bgclr">
              <span
                :style="{ color:sell.clr}"
                style="font-family:poppinssemibold;font-size:14px;color:#000"
              >SELLER</span>
            </v-btn>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex xs12 pt-4>
            <v-text-field
              ref="fullName"
              color="#63028F"
              label="Full Name"
              outlined
              dense
              v-model="fullName"
            ></v-text-field>
            <v-text-field
              ref="email"
              color="#63028F"
              label="Email ID"
              outlined
              dense
              v-model="email"
            ></v-text-field>
            <v-text-field
              type="number"
              ref="pincode"
              color="#63028F"
              label="Pincode"
              outlined
              dense
              v-model="pincode"
            ></v-text-field>
            <v-text-field
              ref="password"
              type="password"
              color="#63028F"
              label="Password"
              outlined
              dense
              v-model="password"
            ></v-text-field>
            <v-text-field
              ref="confirmPassword"
              color="#63028F"
              type="password"
              label="Confirm Password"
              outlined
              dense
              v-model="confirmPassword"
            ></v-text-field>
          </v-flex>
        </v-layout>

        <v-layout wrap>
          <v-flex pt-4 md12 text-left>
            <span
              style="font-family:poppinsbold;font-size:18px;font-weight:400;color:#000"
              class="pl-2 text-capitalize"
            >Verify</span>
          </v-flex>
        </v-layout>
        <v-layout wrap>
          <v-flex py-2 text-left>
            <span
              style="font-family:poppinssemibold;font-size:13px;color:#000"
            >We have sent 6 digit OTP on +91-{{phone}}</span>
          </v-flex>
          <v-flex py-2 text-right>
            <span
              style="font-family:poppinsregular;font-size:13px;color:#DE4D4D;cursor:pointer"
              @click="winStepper"
            >Change</span>
          </v-flex>
          <v-flex xs12>
            <v-text-field
              ref="otp"
              label="Enter your OTP"
              color="#63028F"
              outlined
              dense
              hide-details
              v-model="otp"
            ></v-text-field>
          </v-flex>
          <v-flex text-right>
            <span
              v-if="!otpexpired"
              style="font-family:poppinsregular;font-size:13px;color:#E15050"
            >Please Wait {{ timeLeft }}</span>
            <span
              v-if="otpexpired"
              style="font-family:poppinsregular;font-size:13px;color:#E15050;cursor:pointer"
              @click="sentOTP"
            >Resend OTP</span>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-end>
          <v-flex xs12 md4 pt-4 text-right>
            <v-btn
              block
              dark
              color="#63028F"
              depressed
              class="text-capitalize"
              @click="validateInput"
              :ripple="false"
            >Verify</v-btn>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import store from "./../../store";
export default {
  props: ["pageData", "lastPage"],
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showsnackbar: false,
      timeout: 5000,
      msg: null,
      fullName: null,
      pincode: null,
      email: null,
      password: null,
      confirmPassword: null,
      phone: null,
      otp: null,
      timeLeft: "00:00",
      intervalTimer: null,
      otpexpired: false,
      cust: { bgclr: "#63028F", clr: "white" },
      sell: { bgclr: "#D6D6D6", clr: "black" },
      type: "Client",
    };
  },

  beforeMount() {
    this.setTime(60);
    this.phone = this.pageData.phone;
  },
  methods: {
    customer(val) {
      if (val == true) {
        this.cust.bgclr = "#63028F";
        this.sell.bgclr = "#D6D6D6";
        this.cust.clr = "white";
        this.sell.clr = "black";
        this.type = "Client";
      }
    },
    seller(val) {
      if (val == true) {
        this.sell.bgclr = "#63028F";
        this.cust.bgclr = "#D6D6D6";
        this.sell.clr = "white";
        this.cust.clr = "black";
        this.type = "Seller";
      }
    },
    winStepper() {
      this.$emit("stepper", {
        phone: this.pageData.phone,
        response: null,
        winStep: 0,
      });
    },
    sentOTP() {
      var userData = {};
      userData["phone"] = this.pageData.phone;
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/getsms",
        data: userData,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.setTime(60);
            this.otpexpired = false;
            this.msg = "OTP Sent Successfully";
            this.showsnackbar = true;
          } else {
            this.msg = "Something Went Wrong";
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    validateInput() {
      if (!this.fullName) {
        this.msg = "Please provide your name";
        this.showsnackbar = true;
        return;
      }
      if (!this.email) {
        this.msg = "Please provide your email";
        this.showsnackbar = true;
        return;
      }
      if (!this.pincode) {
        this.msg = "Please provide your pincode";
        this.showsnackbar = true;
        return;
      }
      if (!this.password) {
        this.msg = "Please provide your password";
        this.showsnackbar = true;
        return;
      }
      if (!this.confirmPassword) {
        this.msg = "Please confirm your password";
        this.showsnackbar = true;
        return;
      }
      if (!this.otp) {
        this.msg = "Please provide the OTP received in your mobile number";
        this.showsnackbar = true;
        return;
      }
      if (this.password != this.confirmPassword) {
        this.msg = "Passwords doesn't match";
        this.showsnackbar = true;
        return;
      }
      this.signUp();
    },
    signUp() {
      var userData = {};
      userData["fullname"] = this.fullName;
      userData["email"] = this.email;
      userData["password"] = this.password;
      userData["phone"] = this.phone;
      userData["pincode"] = this.pincode;
      userData["otp"] = this.otp;
      userData["type"] = this.type;
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/weblogin",
        data: userData,
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            store.commit("loginUser", true);
            localStorage.setItem("token", response.data.data.token);
            localStorage.setItem("pincode", response.data.data.pincode);
            // localStorage.setItem("userType", response.data.data.type);

            if (response.data.data.type == "Seller") {
              store.commit("userType", true);
            }
            if (this.lastPage && response.data.data.type == "Client") {
              this.$router.push(this.lastPage.fullPath);
            } else if (response.data.data.type == "Seller") {
              this.$router.push("/sellerRegistration");
            } else if (response.data.data.type == "Client") {
              this.$router.push("/");
            } else this.$router.push("/");
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    setTime(seconds) {
      clearInterval(this.intervalTimer);
      this.timer(seconds);
    },
    timer(seconds) {
      const now = Date.now();
      const end = now + seconds * 1000;
      this.displayTimeLeft(seconds);
      this.countdown(end);
    },
    countdown(end) {
      this.intervalTimer = setInterval(() => {
        const secondsLeft = Math.round((end - Date.now()) / 1000);
        if (secondsLeft == 0) this.otpexpired = true;
        if (secondsLeft < 0) {
          clearInterval(this.intervalTimer);
          return;
        }
        this.displayTimeLeft(secondsLeft);
      }, 1000);
    },
    displayTimeLeft(secondsLeft) {
      const minutes = Math.floor((secondsLeft % 3600) / 60);
      const seconds = secondsLeft % 60;
      var seconds1 = seconds;
      if (seconds < 10) seconds1 = "0" + seconds;
      this.timeLeft = "0" + minutes + " : " + seconds1;
    },
  },
};
</script>
<style scoped>
.separator {
  display: flex;
  align-items: center;
  text-align: center;
}
.separator::before,
.separator::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #c8c8c8;
}
.separator::before {
  margin-right: 0.25em;
}
.separator::after {
  margin-left: 0.25em;
}
</style>